import { publicCreateServiceRequest } from "../api/services/serviceRequestsApi";
import { getErrorMessage } from "../api/errorMessage";

/**
 * POST /v1/public/service-requests (no auth).
 * @param {Record<string, unknown>} apiBody
 * @returns {Promise<{ ok: true, data: unknown } | { ok: false, errorMessage: string }>}
 */
export async function submitServiceRequestPublic(apiBody) {
  try {
    const { data } = await publicCreateServiceRequest(apiBody);
    return { ok: true, data: data ?? {} };
  } catch (e) {
    return { ok: false, errorMessage: getErrorMessage(e) };
  }
}
